// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"2ce49c36","90":"12d8d7cd","170":"c6141ecf","180":"9ba03fff","253":"50d2d6e5","262":"b38666a2","284":"892233c7","438":"8bcc24f3","834":"e628a94c","887":"af88e40b","889":"f2866bfc","954":"cc9acfcb"}[chunkId] + ".chunk.js";
};